import { Box, Grid } from "@mui/material";
import { MenusProps } from "../"
import { escurecerCor } from "../../../../helpers/manipulacaoCores"
import { colors } from "../../bannerColors"
import TemplateOpcoes from "../../Templates/TemplateOpcoes"
import ListOutlinedIcon from '@mui/icons-material/ListOutlined';
import TemplateOpcoesBasicas from "../../Templates/TemplateOpcoesBasicas";
import { useNavigate } from "react-router-dom";
import { useModalStateContext } from "../../../../contexts/ModalStateContext";
import { usePermission } from "../../../PermissionGuard";



export default function CafeMenu({ type }: MenusProps) {

    const navigate = useNavigate();

    const color = colors[type] || "#1E2E6B"
    const textColor = escurecerCor(color)

    const handleRedirect = (path: string) => {
        navigate(`/cafe/${path}`)
    }

    const { handleToggleModal } = useModalStateContext()

    return (
        <Box>
            <Grid container spacing={2}>
                <TemplateOpcoesBasicas
                    {...{ type, textColor }}
                    opcoesBasic={false}
                />

                <Grid container size={{md: 2.4}} spacing={2} alignSelf="flex-start">
                    <TemplateOpcoes
                        title="Lotes de café"
                        color={textColor}
                        items={[
                            {
                                label: "Listar todos",
                                icon: <ListOutlinedIcon fontSize="inherit" />,
                                action: () => handleRedirect("lotes"),
                                disabled: !usePermission("cafe.listar-lotes")
                            },
                        ]}
                    />
                </Grid>
            </Grid>
        </Box>
    )
}

